(function () {
  'use strict';

  var root = document.getElementById('pc-chat-root');
  if (!root) return;
 const url = new URL(window.location.href);

console.log(url.searchParams.get("fromApp"));
console.log(url.searchParams.get("name"));
  var API_URL = root.dataset.api;
  var TOKEN = root.dataset.token;
  var fab = document.getElementById('pc-chat-fab');
  var panel = document.getElementById('pc-chat-panel');
  var closeBtn = document.getElementById('pc-chat-close');
  var welcomeEl = document.getElementById('pc-chat-welcome');
  var messagesEl = document.getElementById('pc-chat-messages');
  var inputEl = document.getElementById('pc-chat-input');
  var sendBtn = document.getElementById('pc-chat-send');
  var presetBtns = document.querySelectorAll('.pc-chat-preset');

  var loading = false;
  var activeAbort = null;
  var chatStarted = false;

  function isPanelOpen() {
    return !panel.hidden;
  }

  function togglePanel(open) {
    panel.hidden = !open;
  }

  function scrollBottom() {
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function showWelcome() {
    if (chatStarted) return;
    welcomeEl.hidden = false;
    messagesEl.hidden = true;
  }

  function hideWelcome() {
    chatStarted = true;
    welcomeEl.hidden = true;
    messagesEl.hidden = false;
  }

  function renderBotMarkdown(textEl, markdown) {
    if (!markdown) {
      textEl.textContent = '';
      return;
    }
    if (typeof marked === 'undefined') {
      textEl.textContent = markdown;
      return;
    }
    const renderer = new marked.Renderer();

renderer.link = function ({ href, text }) {

    if (/\.(mp4|webm|mov|ogg)$/i.test(href)) {
             return `
            <video
                src="${href}"
                controls
                muted
                loop
                playsinline
                webkit-playsinline
                preload="auto"
                disablePictureInPicture
                controlslist="nodownload noplaybackrate"
                style="
                    width:100%;
                    max-width:100%;
                    display:block;
                    border-radius:12px;
                    overflow:hidden;
                    background:#000;
                    object-fit:cover;
                    outline:none;
                "
                onclick="this.paused ? this.play() : this.pause()"
            ></video>
        `;
    }

    if (/\.(jpg|jpeg|png|gif|webp)$/i.test(href)) {
        return `<img src="${href}" style="max-width:100%">`;
    }

    return `<a href="${href}" target="_blank">${text}</a>`;
};

marked.use({
    renderer
});
    var html = marked.parse(markdown, { breaks: true, gfm: true });
    if (typeof DOMPurify !== 'undefined') {
      html = DOMPurify.sanitize(html);
    }
    
    textEl.innerHTML = html;
  }

  function setBotPlainText(bot, text) {
    bot.rawMarkdown = '';
    bot.textEl.textContent = text;
    markBotHasText(bot.wrap);
  }

  function appendUserMessage(text) {
    var wrap = document.createElement('div');
    wrap.className = 'pc-chat-msg pc-chat-msg--user';
    var bubble = document.createElement('div');
    bubble.className = 'pc-chat-msg__bubble';
    bubble.textContent = text;
    wrap.appendChild(bubble);
    messagesEl.appendChild(wrap);
    scrollBottom();
  }

  function appendBotPending() {
    var wrap = document.createElement('div');
    wrap.className = 'pc-chat-msg pc-chat-msg--bot pc-chat-msg--pending';

    var bubble = document.createElement('div');
    bubble.className = 'pc-chat-msg__bubble';

    var spinner = document.createElement('span');
    spinner.className = 'pc-chat-spinner';
    spinner.setAttribute('aria-hidden', 'true');

    var waitLabel = document.createElement('span');
    waitLabel.className = 'pc-chat-wait-label';
    waitLabel.textContent = 'Please wait...';

    var textEl = document.createElement('div');
    textEl.className = 'pc-chat-msg__text';

    bubble.appendChild(spinner);
    bubble.appendChild(waitLabel);
    bubble.appendChild(textEl);
    wrap.appendChild(bubble);
    messagesEl.appendChild(wrap);
    scrollBottom();

    return { wrap: wrap, textEl: textEl, rawMarkdown: '' };
  }

  function markBotHasText(wrap) {
    wrap.classList.add('pc-chat-msg--has-text');
  }

  function finishBotPending(wrap) {
    wrap.classList.remove('pc-chat-msg--pending');
  }

  function setInputDisabled(disabled) {
    loading = disabled;
    sendBtn.disabled = disabled;
    inputEl.disabled = disabled;
    presetBtns.forEach(function (btn) {
      btn.disabled = disabled;
    });
  }
  function ShowFunction() {
    togglePanel(url.searchParams.get("fromApp"))
  }
  togglePanel(false);
  showWelcome();
  ShowFunction()

  fab.addEventListener('click', function () {
    togglePanel(!isPanelOpen());
  });

  closeBtn.addEventListener('click', function () {
    togglePanel(false);
  });

  async function sendMessage(forcedText) {
    var text = (forcedText || inputEl.value || '').trim();
    if (!text || loading) return;

    hideWelcome();
    setInputDisabled(true);
    inputEl.value = '';

    if (activeAbort) {
      activeAbort.abort();
    }
    activeAbort = new AbortController();

    appendUserMessage(text);
    var bot = appendBotPending();

    try {
      var response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + TOKEN
        },
        body: JSON.stringify({ message: text }),
        signal: activeAbort.signal
      });

      if (!response.ok) {
        var errText = 'Request failed (' + response.status + ')';
        try {
          var errJson = await response.json();
          if (errJson.msg) errText = errJson.msg;
        } catch (e) {
          /* ignore */
        }
        throw new Error(errText);
      }

      var reader = response.body.getReader();
      var decoder = new TextDecoder();
      var buffer = '';
      var gotContent = false;

      while (true) {
        var chunk = await reader.read();
        if (chunk.done) break;

        buffer += decoder.decode(chunk.value, { stream: true });
        var lines = buffer.split('\n');
        buffer = lines.pop() || '';

        for (var i = 0; i < lines.length; i++) {
          var line = lines[i];
          if (line.indexOf('data: ') !== 0) continue;

          var dataStr = line.slice(6);
          if (dataStr === '[DONE]') continue;

          try {
            var data = JSON.parse(dataStr);

            if (data.error) {
              bot.rawMarkdown += (gotContent ? '\n' : '') + '[Error: ' + data.error + ']';
              renderBotMarkdown(bot.textEl, bot.rawMarkdown);
              gotContent = true;
              markBotHasText(bot.wrap);
              scrollBottom();
              continue;
            }

            var piece = data.content || '';
            if (piece) {
              bot.rawMarkdown += piece;
              renderBotMarkdown(bot.textEl, bot.rawMarkdown);
              gotContent = true;
              markBotHasText(bot.wrap);
              scrollBottom();
            }
          } catch (e) {
            /* ignore parse */
          }
        }
      }

      if (!gotContent) {
        setBotPlainText(bot, 'Sorry, no response. Please try again.');
      }
    } catch (err) {
      if (err.name === 'AbortError') {
        if (!bot.rawMarkdown) {
          setBotPlainText(bot, 'Cancelled.');
        }
      } else {
        setBotPlainText(bot, 'Sorry: ' + (err.message || 'unknown error'));
      }
    } finally {
      finishBotPending(bot.wrap);
      setInputDisabled(false);
      activeAbort = null;
      scrollBottom();
    }
  }

  sendBtn.addEventListener('click', function () {
    sendMessage();
  });

  inputEl.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  });

  presetBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var msg = btn.getAttribute('data-message') || btn.textContent.trim();
      sendMessage(msg);
    });
  });
})();